module.exports = __webpack_public_path__ + "static/media/aquisition.682d09cc.jpg";